import React, { ReactNode } from 'react';
import styles from './Card.module.css';

interface CardWrapperProps {
  children: ReactNode
  customClass?:string
  customStyle?:React.CSSProperties
}

const CardWrapper: React.FC<CardWrapperProps> = ({ children,customClass,customStyle }) => {
    const combinedClassName = `${styles.cardWrapper} ${customClass|| ''}`.trim();
  return <div className={combinedClassName} style={customStyle}>{children}</div>;
};

export default CardWrapper;
